import { createApp, h } from "vue";
import App from "./App.vue";
import router from "./router/index";
import store from "./store";
import Keycloak from "keycloak-js";

import "./assets/sass/app.scss";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import VuePdf from "vue3-pdfjs";
import {
  faPowerOff,
  faTrashCan,
  faPencil,
  faList,
  faGlobe,
  faFileExport,
  faLayerGroup,
  faChevronUp,
  faUpload,
  faGears,
  faCopy,
  faAtom,
  faListCheck,
  faFlask,
  faCalendar,
  faFile,
} from "@fortawesome/free-solid-svg-icons";

const env = window.environment;

library.add(
  faPowerOff,
  faTrashCan,
  faPencil,
  faList,
  faGlobe,
  faFileExport,
  faLayerGroup,
  faChevronUp,
  faUpload,
  faGears,
  faCopy,
  faAtom,
  faListCheck,
  faFlask,
  faCalendar,
  faFile,
);

let initOptions = {
  url: env.data.keycloakUrl,
  realm: env.data.keycloakRealm,
  clientId: env.data.keycloakClient,
  onLoad: "check-sso",
};

let keycloak = new Keycloak(initOptions);

keycloak.init({ onLoad: initOptions.onLoad }).then((auth) => {
  if (!auth) {
    keycloak.login();
  }

  const app = createApp({
    data: () => ({
      keycloak: keycloak,
      token: keycloak.token,
    }),
    render: () => h(App, { props: { keycloak: keycloak } }),
  })
    .use(store)
    .use(VuePdf)
    .use(router)
    .component("font-awesome-icon", FontAwesomeIcon)
    .mount("#app");

  // TODO remove trailing slash when the infra is fixed. and make the specific routes add it
  store.state.baseUrl = window._env_.VUE_APP_BFF_URL + "/";
  store.state.baseUrlNymusX = window._env_.VUE_APP_NYMUSX_URL + "/";
  // store.state.baseUrlNymusX = 'https://api.nymus.eu/'
  //store.state.baseUrlNymusX = 'https://test-api.nymus.eu/'

  router.app = app;
});
export default keycloak;
